import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-card',
  imports: [CardModule, CommonModule, TranslocoModule],
  templateUrl: './custom-card.component.html',
  styleUrl: './custom-card.component.scss',
  standalone: true,
})
export class CustomCardComponent {
  @Input() link!: string;
  @Input() icon!: string;
  @Input() title!: string;
  @Input() text?: string;
  @Input() style?: object;

  private router = inject(Router);

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}
